import { Component } from '@angular/core';

@Component({
  selector: 'reviews-recommended-icon',
  template: `
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 278.1 249.5"
      style="enable-background:new 0 0 278.1 249.5;"
      xml:space="preserve"
    >
      <style type="text/css">
        .st0 {
          fill: #fa3e3e;
        }
        .st1 {
          fill: #ffffff;
        }
      </style>
      <g>
        <path
          class="st0"
          d="M196.5,15.9H81.7c-27.6,0-50.1,22.5-50.1,50.1v69.6c0,27.6,22.5,50.1,50.1,50.1h-0.4v47.9l69.4-47.9h45.8
      c27.6,0,50.1-22.5,50.1-50.1V66C246.6,38.5,224,15.9,196.5,15.9z"
        />
        <polygon
          class="st1"
          points="139.1,60 152.3,86.8 182,91.2 160.5,112.1 165.6,141.6 139.1,127.7 112.5,141.6 117.6,112.1
      96.1,91.2 125.8,86.8  "
        />
      </g>
    </svg>
  `,
  styles: [
    `
      svg {
        width: 1.2em;
        height: 1em;
      }
    `,
  ],
  standalone: false,
})
export class RecommendedIconComponent {}
